import { Get } from '../helpers';
import { SuperAdminNotification } from '@/types/super-admin-notifications.types';

export function GetSuperAdminNotifications(): Promise<SuperAdminNotification[]> {
  return Get({ path: '/v3/admin/notifications/super-admin-notifications' });
}
